import React from "react";

const Footer = () => {
    return (
        <footer>
            <p>© {new Date().getFullYear()} Talal Nadeem. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
